<template>
  <div>
    <div class="div-loading">
      <Loading type="line" :center="false" v-show="loading" />
      <b-row>
        <b-col sm="12">
          <TableTotalRecords :totalRecords="content.totalRecords" />
        </b-col>
      </b-row>
    </div>
    <ScrollBar id="chartOfAccounts-rent" :minHeight="400" :maxHeight="800">
      <table class="table table-responsive-xs">
        <thead>
          <tr>
            <th><span class="title-header">Nome</span></th>
            <th class="text-center"><span class="title-header">Tipo</span></th>
            <th class="text-center"><span class="title-header">Plano de Conta</span></th>
            <th></th>
          </tr>
        </thead>
        <tbody v-for="costCenter in content.data" :key="costCenter.id">
          <tr>
            <td>
              <div class="icon-round side-by-side" :style="'background-color:' + costCenter.color">
                <i :class="costCenter.icon"></i>
              </div>
              <div class="link side-by-side" @click="updateCostCenter(costCenter)">
                {{ costCenter.name }}
              </div>
            </td>

            <td class="text-center">
              <div v-if="costCenter.typeName === 'Despesa'" class="badge badge-expense td-margin">Despesa</div>
              <div v-else class="badge badge-revenue td-margin">Receita</div>
            </td>

            <td class="text-center">
              <div class="total-chart-of-accounts" @click="openModalChartOfAccounts(costCenter)">
                <span class="title">{{ costCenter.totalChartOfAccounts }}</span>
              </div>
            </td>

            <td class="text-right">
              <b-row>
                <b-col sm="8" />
                <b-col sm="1">
                  <Button :_key="costCenter.id" type="danger" classIcon="fa-solid fa-trash" size="small"
                    :params="costCenter.id" :clicked="confirmDelete" />
                </b-col>
              </b-row>
            </td>
          </tr>
        </tbody>
        <tbody v-show="content.totalRecords === 0">
          <tr>
            <td colspan="8"><span class="title">Nenhum registro encontrado!</span></td>
          </tr>
        </tbody>
      </table>
    </ScrollBar>

    <Modal title="Centro de Custo" :width="500" :height="250" v-show="showModal('costCenterCreateUpdate')">
      <CostCenterCreateUpdate />
    </Modal>

    <Modal title="Tem certeza que deseja excluir?" :width="500" :height="250" v-show="showModal('confirm')">
      <Confirmation :isModal="false" type="danger" :confirmed="deleteCostCenter" />
    </Modal>

    <Modal :title="costCenterSelected.name" :width="750" :height="250" :onHideModal="getAll" v-if="showModal('chartOfAccounts')">
      <ChartOfAccountsCreateUpdateList :costCenter="costCenterSelected" />
    </Modal>

  </div>
</template>

<script>

import Button from "@nixweb/nixloc-ui/src/component/forms/Button";
import Confirmation from "@nixweb/nixloc-ui/src/component/shared/Confirmation.vue";
import Loading from "@nixweb/nixloc-ui/src/component/shared/Loading.vue";
import Modal from "@nixweb/nixloc-ui/src/component/forms/Modal";
import ScrollBar from "@nixweb/nixloc-ui/src/component/layout/ScrollBar.vue";
import TableTotalRecords from "@nixweb/nixloc-ui/src/component/shared/TableTotalRecords.vue";

import CostCenterCreateUpdate from "./CostCenterCreateUpdate.vue";
import ChartOfAccountsCreateUpdateList from '../chart-of-accounts/ChartOfAccountsCreateUpdateList.vue'

import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
  name: "CostCenterList",
  components: {
    Button,
    Confirmation,
    CostCenterCreateUpdate,
    Loading,
    Modal,
    ScrollBar,
    TableTotalRecords, ChartOfAccountsCreateUpdateList
  },
  data() {
    return {
      urlGetApi: "/api/v1/finance/cost-center/get-all",
      urlDeleteApi: "/api/v1/finance/cost-center/delete",
      urlGetApiChartOfAccounts: "/api/v1/finance/chart-of-accounts/get-all",
      urlDeleteApiChartOfAccounts: "/api/v1/finance/chart-of-accounts/delete",
      loading: true,
      content: { data: [], totalRecords: 0 },
      costCenterSelected: {},
    };
  },
  computed: {
    ...mapGetters("generic", ["showModal", "event"]),
  },
  mounted() {
    this.getAll();
  },
  methods: {
    ...mapActions("generic", ["getApi", "deleteAllApi"]),
    ...mapMutations("generic", ["addEvent", "hideModal", "openModal", "removeLoading"]),
    getAll() {
      this.loading = true;
      const params = {
        url: this.urlGetApi,
        obj: { noPaginated: true },
      };

      this.getApi(params).then((response) => {
        this.content.data = response.content.data;
        this.content.totalRecords = response.content.totalRecords;
        this.loading = false;
      });
    },
    updateCostCenter(costCenter) {
      this.addEvent({ name: "costCenterUpdate", data: costCenter });
    },
    confirmDelete(costCenterId) {
      this.costCenterId = costCenterId;
      this.removeLoading([costCenterId]);
      this.openModal("confirm");
    },
    deleteCostCenter() {
      const params = { url: this.urlDeleteApi, selected: [this.costCenterId] };
      this.deleteAllApi(params).then((response) => {
        if (response.success) {
          this.getAll();
          this.hideModal("confirm");
          this.removeLoading(["confirm"]);
        }
      });
    },
    openModalChartOfAccounts(costCenter) {
      this.costCenterSelected = costCenter;
      this.openModal("chartOfAccounts");
      this.addEvent({ name: "getAllChartOfAccounts" });
    }
  },
  watch: {
    event: {
      deep: true,
      handler(event) {
        if (event.name === "costCenterSaved") {
          this.getAll();
          return;
        }

        if (event.name === "costCenterCreate" || event.name === "costCenterUpdate") {
          this.openModal("costCenterCreateUpdate");
          this.removeLoading(["btncCostCenterCreate"]);
        }
      },
    },
  },
};
</script>

<style scoped>
.table th,
.table td {
  height: 10px !important;
  padding-top: 7px !important;
  padding-bottom: 5px !important;
  padding-right: 5px !important;
  padding-left: 10px !important;
  border-bottom: 0 !important;
}

.table-sub {
  background-color: #f3f3f3;
}

.td-description {
  max-width: 300px !important;
  word-wrap: break-word !important;
  font-size: 14px;
  color: #757d8c;
  font-style: italic;
}

.td-chart-of-accounts {
  width: 400px;
}

.title-header {
  font-size: 14px;
  color: #757d8c;
  font-weight: 400;
  text-transform: uppercase;
}

.group {
  background-color: #fafafc;
  font-size: 14px;
  font-weight: 400;
}

.title-group {
  font-size: 14px;
  margin-left: 10px;
}

.div-warning {
  margin-bottom: 20px;
}

.td-margin {
  margin-top: 10px;
}

.badge {
  font-size: 13px !important;
  margin-left: 5px;
  border-radius: 25px !important;
  padding: 6px !important;
  color: #fff;

}

.badge-revenue {
  background-color: #007BFF;
}

.badge-expense {
  background-color: #FF5454;
}

.add-chart-of-accounts {
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  margin-right: 10px;
  color: #577696 !important;
}

.link {
  margin-top: 8px;
  color: #3f529b;
  font-size: 14.5px;
  font-weight: 400;
  cursor: pointer;
}

.div-loading {
  margin-top: 10px;
}

.total-chart-of-accounts {
  margin-top: 8px;
  background: #f3f4f6;
  color: #374151;
  border: 1px solid #e6e7eb;
  padding: 3px 10px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 500;
  width: 60px;
  margin: auto;
  cursor: pointer;
}

.total-chart-of-accounts:hover {
  background: #e3e5ed;
}

.danger {
  color: #f0134d;
  cursor: pointer;
}

.separator {
  height: 8px;
}

.icon-round {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
}

.icon-round i {
  font-size: 14px;
  line-height: 1;
}
</style>
